import { Component, OnInit, ViewChild, ElementRef, Inject, ViewEncapsulation, EventEmitter, Output, HostListener } from '@angular/core';
import { scheduler } from '../../../../../../../../../../dhtmlx-scheduler';
import { ActivatedRoute, Router } from '@angular/router';
import { select, Store } from '@ngrx/store';
import { CoreUiPartialState, EventService, getBranch, getBrandDefaults } from '@pos-app/core-ui';
import { takeUntil } from 'rxjs/operators';
import { Subject, BehaviorSubject } from 'rxjs';
import { Legend, ListWorkshopJobTypes, ListWorkshopTasks, ListWorkshopVehicleStatus, OrderArray, ResourceList, TaskArray } from '@pos-app/data';
import {
  allUnallocateSectionID,
  convert,
  get_formatted_duration,
  getformatedDate,
  getformatedTime,
  getformatedTimeHHMM,
  getListWorkshopJobTypesFormattedWithKey,
  getSplitLine,
  schedulerAppValue,
} from '../scheduler-helper';
import moment from 'moment';

import { UntypedFormGroup } from '@angular/forms';
import { NgbDateStruct, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ConfirmationService } from 'primeng/api';
import { CustomersPartialState } from '../../customers/+state/customers.reducer';
import { SplitOrderContent } from '../splitorder/splitorder.component';
import { checkInBreakRange } from '../schedulerBreak-helper';
import { FetchJdeOrder } from '../../orders/+state/orders.actions';
import { SchedulerSetWorkshopHours } from '../workshop/schedulerHours/schedulerSetWorkshopHours.component';
import { NgbdModalResourceContent } from '../resource/resource.component';
import { SchedulerSetWorkshopDays } from '../workshop/schedulerDays/schedulerSetWorkshopDays.component';
import { NgbdModalOrderDetailCard } from '../orderDetailCard/orderDetailCard.component';
import { NgbdModalTaskDetailCard } from '../taskDetailCard/taskDetailCard.component';
import { DOCUMENT } from '@angular/common';

@Component({
    encapsulation: ViewEncapsulation.None,
    selector: 'app-scheduler-week',
    styleUrls: ['./schedulerWeek.component.scss'],
    templateUrl: './schedulerWeek.component.html',
    standalone: false
})
export class SchedulerWeekComponent implements OnInit {
  @ViewChild('scheduler_here', { static: true }) schedulerContainer!: ElementRef;
  @ViewChild('content') modalBox: any;
  @Output() onFetchOrderFromJDE = new EventEmitter();
  unSubscribe$ = new Subject<void>();
  year: number = this.route.snapshot.params.year;
  month: number = this.route.snapshot.params.month;
  day: number = this.route.snapshot.params.day;
  viewType: string = this.route.snapshot.params.viewType;
  mode: string = this.route.snapshot.params.mode;
  isEditMode: boolean = this.mode === 'edit' ? true : false;

  defaultBranch: string;
  currentStartDate: string;
  currentDate: string;
  previousDate: string;
  currentEventData: any;
  currentTaskData: any;
  clicked: Boolean = false;
  resourceList: ResourceList[];
  previousTechnicianID: number;
  globalStart: string;
  globalEnd: string;
  previousGlobalDate: string;
  nextGlobalDate: string;
  listWorkshopTasks: ListWorkshopTasks[];
  orderArray: OrderArray[];
  taskArray: TaskArray[];
  technician: ResourceList[];
  unAllocatedOrders: OrderArray[];
  unAllocatedFloater: OrderArray[];
  orderViewLightbox: any;
  eventViewLightbox: any;
  newScheduledHrs: number;
  previousTechnicianIDData: any;
  listWorkshopVehicleStatus: ListWorkshopVehicleStatus[];
  listWorkshopJobTypes: ListWorkshopJobTypes[];
  otherResources: ResourceList[];
  searchOrderForm: UntypedFormGroup;
  validSearch: boolean = false;
  globalData: ResourceList;
  availableResources: ResourceList;
  customFunctionLoaded: boolean = false;
  showingContextMenu: boolean = false;
  floaterToggleState: boolean = false;
  salesTogglestate: boolean = false;
  loading = new BehaviorSubject<boolean>(false);
  showSMS: boolean = false;
  workshopLegend: Legend;
  isLegendView: boolean = false;
  isOrderDetailsCardView: boolean = false;
  isEventCollision: boolean = false;
  jobTypeLegend: Legend[];
  vehicleStatusLegend: Legend[];
  customerTypeLegend: Legend[];
  orderDetailCardLoaded: boolean = false;
  taskDetailCardLoaded: boolean = false;
  searchOrderStatus: boolean = false;
  forwardDirection: boolean = true;
  adjustedCurrentDate: string;
  dateArray: any;
  resourceListForWeekView: Array<any> = [];
  resourceListForWeekViewOther: Array<any> = [];
  fullScreen: boolean = false;
  elem: any;
  totalResourceAvailableHours: number = 0;
  totalResourceBookedHours: number = 0;
  totalResourceHours: number = 0;
  skipDateCount: number = 0;
  show: boolean = false;
  showLegendModal: boolean = false;
  showSelectDateModal: boolean = false;
  dateToAddResource: string;
  currentMonth: number;
  brandDefaults: any;

  constructor(
    private eventService: EventService,
    private customerStore: Store<CustomersPartialState>,
    private coreUIStore: Store<CoreUiPartialState>,
    private route: ActivatedRoute,
    private modalService: NgbModal,
    private confirmationService: ConfirmationService,
    private router: Router,
    @Inject(DOCUMENT) private document: any
  ) {}

  @HostListener('window:scroll', ['$event']) onScrollEvent($event) {
    scheduler.config.tooltip_offset_y = -window.scrollY;
  }
  @HostListener('document:click', ['$event']) click($event) {
    if (this.customFunctionLoaded) {
      scheduler?.removeContextMenu();
      this.showingContextMenu = false;
    }
  }

  ngOnInit() {
    if (!localStorage.getItem('preload')) {
      localStorage.setItem('preload', 'preloaded');
      this.loading.next(true);
      location.reload();
    } else {
      this.loading.next(false);
      localStorage.removeItem('preload');
    }

    this.getBranchInfo();
    this.getViewStatus();
    this.getStartDate();
    if (this.viewType === 'week') {
      this.fetchWorkshopTaskList().then((data: any) => {
        if (data) {
          this.listWorkshopTasks = data?.SearchResults;
          this.fetchWorkshopJobType().then((data: ListWorkshopJobTypes) => {
            if (data) {
              this.listWorkshopJobTypes = getListWorkshopJobTypesFormattedWithKey(data?.SearchResults);
              this.getListWorkshopVehicleStatus().then((value: any) => {
                this.listWorkshopVehicleStatus = value?.SearchResults;
                this.initializeWeekView();
              });
            }
          });
        }
      });
    }
    this.elem = document.documentElement;
  }

  initializeWeekView() {
    this.fetchRecordsForWeekView().then((data: any) => {
      if (data && data.length) {
        this.loadDataToWeeklyScheduler(this);
      }
    });
  }

  getBranchInfo() {
    this.coreUIStore.pipe(takeUntil(this.unSubscribe$), select(getBranch)).subscribe((x) => {
      this.defaultBranch = x?.BranchCode;
    });
    this.coreUIStore
      .select(getBrandDefaults)
      .pipe(takeUntil(this.unSubscribe$))
      .subscribe((data) => {
        this.brandDefaults = data;
      });
  }
  getStartDate() {
    this.currentDate = this.day.toString() + '/' + this.month.toString() + '/' + this.year.toString();
    this.adjustedCurrentDate = moment(this.currentDate, 'DD/MM/YYYY').subtract(1, 'days').format('DD/MM/YYYY');
  }
  getViewStatus() {
    this.viewType = 'week';
  }
  fetchRecordsForWeekView() {
    return new Promise((resolve) => {
      this.skipDateCount = 0;
      this.getStartDate();
      this.loading.next(true);
      this.eventService
        .fetchRecordsForWeek({
          startDate: this.adjustedCurrentDate,
          numberOfDays: 5,
          branch: this.defaultBranch,
        })
        .pipe(takeUntil(this.unSubscribe$))
        .subscribe((res: any) => {
          this.loading.next(false);
          if (res) {
            //consider first date as res?.dateArray[0]?.date;
            //get calander next date from res?.dateArray[0]?.date

            this.adjustedCurrentDate = '';
            this.dateArray = res?.dateArray;
            if (moment(new Date()).isBefore(moment(res?.dateArray[res?.dateArray.length - 1]?.date, 'DD/MM/YYYY'))) {
              this.showSMS = true;
            } else {
              this.showSMS = false;
            }
            this.dateArray.map((el, index) => {
              //find all the skip dates between  res?.dateArray[0]?.date and res?.dateArray[res?.dateArray.length-1]?.date
              if (index === 0) {
                const startDateParts = res?.dateArray[0]?.date.split('/').map(Number);
                const endDateParts = res?.dateArray[res?.dateArray.length - 1]?.date.split('/').map(Number);
                const startDate = new Date(startDateParts[2], startDateParts[1] - 1, startDateParts[0]);
                const endDate = new Date(endDateParts[2], endDateParts[1] - 1, endDateParts[0]);
                let current = new Date(startDate);
                const dateSet = new Set(res?.dateArray.map((d) => d.date));
                while (current <= endDate) {
                  const d =
                    current.getDate().toString().padStart(2, '0') +
                    '/' +
                    (current.getMonth() + 1).toString().padStart(2, '0') +
                    '/' +
                    current.getFullYear().toString();
                  if (!dateSet.has(d)) {
                    this.skipDateCount++;
                  }
                  current.setDate(current.getDate() + 1);
                }
              }

              el.resourceHoursArray.map((elSub, index) => {
                if (elSub?.ResourceID === 0) {
                  elSub.ResourceID = 1;
                }
                this.resourceListForWeekView = [
                  {
                    resourceID: elSub?.ResourceID,
                    resourceName: elSub?.ResourceName,
                    includeInBillableHoursTF: elSub?.IncludeInBillableHoursTF,
                    resourceDesc1: elSub?.ResourceDesc1,
                    resourceDesc2: elSub?.ResourceDesc2,
                    genericResourceTF: elSub?.GenericResourceTF,
                  },
                  ...this.resourceListForWeekView,
                ];
              });
            });
            this.resourceListForWeekView = this.getUniqueResourceList();
            this.resourceListForWeekView.sort(function (a, b) {
              return a.resourceID - b.resourceID;
            });
            resolve(this.resourceListForWeekView);
          }
        });
    });
  }
  getUniqueResourceList() {
    let output = this.resourceListForWeekView.filter((obj, index, arr) => {
      return (
        this.resourceListForWeekView.findIndex((o) => {
          return JSON.stringify(o) === JSON.stringify(obj);
        }) === index
      );
    });
    return output;
  }
  loadDataToWeeklyScheduler(context: any) {
    if (!(scheduler as any).$_initOnce) {
      (scheduler as any).$_initOnce = true;
      this.addPlugins();
      this.addConfig();
      this.addLabels();
      this.addEventBar();
      this.addLightBox();
      this.addworkshopSchedulerEventWeeklyView(this);
      this.addCustomWorkshopSchedulerEventWeeklyView(this);
      this.addworkshopSchedulerTemplates(this);
      this.addWeeklyView();
      const dp = scheduler.createDataProcessor({
        event: {
          create: (data: any) => {
            console.log('create', data?.id);
          },
          update: (data: any) => {
            console.log('update', data);
          },
          delete: (id: number) => {
            console.log('deleted', id);
          },
        },
      });
      dp.attachEvent('onBeforeDataSending', function (id, state, data) {
        let resourceIDList;
        if (allUnallocateSectionID?.some((el) => el === data.section_id)) {
          resourceIDList = [];
        } else {
          resourceIDList = scheduler.getResourceList(
            data?.section_id?.toString().indexOf(',') > 0
              ? data?.section_id?.split(',').map(function (n) {
                  return Number(n);
                })
              : [data?.section_id],
            context.previousTechnicianIDData
          );
        }
        if (
          data?.keyCode &&
          (state === 'inserted' || state === 'updated') &&
          id &&
          data
          //  &&
          // !allUnallocateSectionID.some((el) => el === data.section_id)
        ) {
          const dataToCreateOrUpdate = {
            startDate: convert(data?.start_date),
            endDate: convert(data?.end_date),
            startTime: Number(moment(data?.start_date).format('HH:mm:ss').replace(/:|_/g, '')),
            endTime: Number(moment(data?.end_date).format('HH:mm:ss').replace(/:|_/g, '')),
            branch: context.defaultBranch,
            jobID: state === 'inserted' ? 0 : data?.data?.JobID,
            taskCode: data?.keyCode,
            description: data?.text,
            scheduledHours: context.newScheduledHrs,
            resources: resourceIDList,
            jobOwner: state === 'inserted' ? '' : data?.data?.JobOwner,
          };
          scheduler.customCreateOrUpdateEvent(dataToCreateOrUpdate, 0, state);
          return true;
        } else if (data.keyCode && state === 'deleted' && id && data && !allUnallocateSectionID.some((el) => el === data.section_id)) {
          const dataToDelete = {
            jobID: data?.data?.JobID,
            startDate: data?.data?.WorkshopStartDate,
            endDate: data?.data?.WorkshopEndDate,
            startTime: data?.data?.WorkshopStartTime,
            endTime: data?.data?.WorkshopEndTime,
            description: data?.data?.TaskDescription,
            scheduledHours: data?.data?.ScheduledHours,
            branch: context.defaultBranch,
            taskCode: data?.keyCode,
            resources: [],
          };
          scheduler.customDeleteEvent(id, dataToDelete);
          return true;
        } else if (!data.keyCode && state === 'updated' && !allUnallocateSectionID.some((el) => el === data.section_id)) {
          const orderDataToUpdate = {
            branch: context.defaultBranch,
            jobID: data?.data?.JobID,
            scheduledHours: context.newScheduledHrs ?? Number(data?.allocatedHours) + Number(data?.extraHours),
            orderNumber: data?.data?.OrderNumber,
            orderType: data?.data?.OrderType,
            description: data?.description ?? data?.data?.Description,
            resources: resourceIDList,
            startTime: Number(moment(data?.start_date).format('HH:mm:ss').replace(/:|_/g, '')),
            endTime: Number(moment(data?.end_date).format('HH:mm:ss').replace(/:|_/g, '')),
            startDate: convert(data?.start_date),
            endDate: convert(data?.end_date),
            jobTypeCode: data?.key,
            vehicleStatusCode: data?.data?.VehicleStatusCode ?? '00',
            jobOwner: data?.data?.JobOwner ?? '',
          };
          scheduler.customUpdateOrder(orderDataToUpdate);
          return true;
        } else if (!data.keyCode && state === 'updated' && allUnallocateSectionID.some((el) => el === data.section_id)) {
          const orderDataToUpdate = {
            branch: context.defaultBranch,
            jobID: data?.data?.JobID,
            status: data?.data?.status ?? 10,
            scheduledHours: context.newScheduledHrs,
            orderNumber: data?.data?.OrderNumber,
            orderType: data?.data?.OrderType,
            description: data?.data.Description,
            resources: resourceIDList,
            startTime: Number(moment(data?.start_date).format('HH:mm:ss').replace(/:|_/g, '')),
            endTime: Number(moment(data?.end_date).format('HH:mm:ss').replace(/:|_/g, '')),
            startDate: convert(data?.start_date),
            endDate: convert(data?.end_date),
          };
          scheduler.customUpdateOrder(orderDataToUpdate);
          return true;
        } else {
          return false;
        }
      });
    }
    if (this.dateArray && this.dateArray.length > 0) {
      scheduler.updateView(
        new Date(
          Number(this.dateArray[0]?.date.split('/')[2]),
          Number(this.dateArray[0]?.date.split('/')[1]) - 1,
          Number(this.dateArray[0]?.date.split('/')[0])
        )
      );
    }

    this.addTechnicianToWeeklyView();
    this.addOrderToWeeklyViewParent();
  }

  addOrderToWeeklyViewParent() {
    this.resourceListForWeekView.map((el, index) => {
      this.addOrderToWeeklyView(el.resourceID);
      this.totalResourceAvailableHours = 0;
      this.totalResourceBookedHours = 0;
      this.totalResourceHours = 0;
      this.dateArray.forEach((item: any) => {
        this.totalResourceAvailableHours = this.totalResourceAvailableHours + item.TotalResourceAvailableHours;
        this.totalResourceBookedHours = this.totalResourceBookedHours + item.TotalResourceBookedHours;
        this.totalResourceHours = this.totalResourceHours + item.TotalResourceHours;

        item.resourceHoursArray.forEach((dayresource: any) => {
          if (el.resourceID === dayresource.ResourceID) {
            if (el.resourceID === 1) {
              scheduler.parse([
                {
                  start_date: getformatedDate(item?.date) + ' ' + '00:10',
                  end_date: getformatedDate(item?.date) + ' ' + '23:50',
                  text: item?.TotalResourceAvailableHours + '|' + item?.TotalResourceBookedHours + '|' + item?.TotalResourceHours,
                  section_id: dayresource?.ResourceID,
                  info: 'info',
                  readonly: true,
                },
              ]);
            } else {
              scheduler.parse([
                {
                  start_date: getformatedDate(item?.date) + ' ' + '00:10',
                  end_date: getformatedDate(item?.date) + ' ' + '23:50',
                  text: dayresource?.AvailableHours + '|' + dayresource?.BookedHours,
                  section_id: dayresource?.ResourceID,
                  info: 'info',
                  readonly: true,
                },
              ]);
            }
          }
        });
      });
    });
  }

  addOrderToWeeklyView(resourceId: any) {
    if (!this.dateArray) return;

    const collectedData: any[] = [];

    this.dateArray.forEach((el) => {
      if (el?.jobArray && el.jobArray.length > 0) {
        el.jobArray.forEach((job, index) => {
          if (job?.ResourceAssigned?.some((res) => res.ResourceID === resourceId || (res.ResourceID === 0 && resourceId === 1))) {
            if (this.isEditMode) {
              collectedData.push({
                start_date: getformatedDate(el?.date) + ' ' + getformatedTimeHHMM((job?.WorkshopStartTime).toString()),
                end_date: getformatedDate(el?.date) + ' ' + getformatedTimeHHMM((job?.WorkshopEndTime).toString()),
                text: job?.Description,
                section_id: resourceId,
                data: job,
                keyCode: job?.TaskCode,
                listWorkshopTask: this.listWorkshopTasks,
              });
            } else {
              collectedData.push({
                start_date: getformatedDate(el?.date),
                end_date: getformatedDate(el?.date),
                text: job?.Description,
                section_id: resourceId,
                data: job,
                keyCode: job?.TaskCode,
                listWorkshopTask: this.listWorkshopTasks,
              });
            }
          }
        });
      }
    });
    if (this.isEditMode) {
      collectedData.length > 0 && this.isEditMode && scheduler.parse(collectedData);
    } else {
      if (collectedData.length === 1) {
        collectedData[0] = {
          ...collectedData[0],
          start_date: collectedData[0]?.start_date + ' ' + '00:20',
          end_date: collectedData[0]?.start_date + ' ' + '23:30',
        };
        scheduler.parse([collectedData[0]]);
      } else if (collectedData.length > 1) {
        let startDateTime;
        let endDateTime;
        this.dateArray.forEach((item, index) => {
          const collectedDataForDate = collectedData.filter((dataItem) => {
            const date = moment(dataItem.start_date).format('DD/MM/YYYY');
            return item.date === date;
          });
          if (collectedDataForDate.length > 0) {
            const durationValue = collectedDataForDate?.length > 4 ? 4 : collectedDataForDate?.length || 1;
            const duration = 24 / durationValue;
            collectedDataForDate.forEach((dataItem, dataIndex) => {
              // For every 5th dataItem, reset startDateTime to initial value
              if (dataIndex > 3 && dataIndex % 4 === 0) {
                startDateTime = moment(collectedDataForDate[0].start_date, 'YYYY-MM-DD HH:mm').add(0.2, 'hours').format('YYYY-MM-DD HH:mm');
              }

              if (dataIndex === 0) {
                startDateTime = moment(dataItem.start_date, 'YYYY-MM-DD HH:mm').add(0.2, 'hours').format('YYYY-MM-DD HH:mm');
                endDateTime = moment(dataItem.start_date, 'YYYY-MM-DD HH:mm')
                  .add(duration - 0.2, 'hours')
                  .format('YYYY-MM-DD HH:mm');
                dataItem = { ...dataItem, start_date: startDateTime, end_date: endDateTime };
                scheduler.parse([dataItem]);
                startDateTime = moment(dataItem.end_date, 'YYYY-MM-DD HH:mm').add(0.2, 'hours').format('YYYY-MM-DD HH:mm');
              } else {
                const endDateTimeValue = moment(startDateTime, 'YYYY-MM-DD HH:mm')
                  .add(duration - 0.2, 'hours')
                  .format('YYYY-MM-DD HH:mm');
                dataItem = { ...dataItem, start_date: startDateTime, end_date: endDateTimeValue };
                scheduler.parse([dataItem]);
                startDateTime = moment(dataItem.end_date, 'YYYY-MM-DD HH:mm').add(0.2, 'hours').format('YYYY-MM-DD HH:mm');
              }
            });
          }
        });
      }
    }
  }
  addTechnicianToWeeklyView() {
    const resourceListForWeekAll = this.resourceListForWeekView;
    this.resourceListForWeekView = this.resourceListForWeekView
      .filter((el) => el.genericResourceTF === false)
      .slice()
      .sort((a, b) => {
        const getSurname = (name: string) => {
          const parts = name?.trim().split(' ');
          return (parts && parts.length > 1 ? parts[parts.length - 1] : '').toLowerCase();
        };
        const aSurname = getSurname(a.resourceName);
        const bSurname = getSurname(b.resourceName);
        return aSurname.localeCompare(bSurname);
      });
    this.resourceListForWeekViewOther = resourceListForWeekAll
      .filter((el) => el.genericResourceTF === true)
      .slice()
      .sort((a, b) => {
        const getSurname = (name: string) => {
          const parts = name?.trim().split(' ');
          return (parts && parts.length > 1 ? parts[parts.length - 1] : '').toLowerCase();
        };
        const aSurname = getSurname(a.resourceName);
        const bSurname = getSurname(b.resourceName);
        return aSurname.localeCompare(bSurname);
      });
    this.resourceListForWeekView = this.resourceListForWeekView.concat(this.resourceListForWeekViewOther);
    this.technician = this.resourceListForWeekView.map(function (el, index) {
      let obj = Object.assign({}, el);
      const description = (el.resourceDesc1 ? `Desc 1: ${el.resourceDesc1}` : '') + (el.resourceDesc2 ? `\n Desc 2:  ${el.resourceDesc2}` : '');

      obj.key = el.resourceID;
      obj.label = `<div style="display:flex; flex-direction:column; align-items:flex-start; justify-content:flex-start">
        <div style="text-align:left; width:100%;">${el.resourceName}</div>
        <div style="display:flex; flex-direction:row; justify-content:space-between; align-items:center; width:100%; margin-top:2px;">
          ${
            !el.includeInBillableHoursTF
              ? `<div title='Resource not included in available hours' style='font-size: 10px; color: #888;'>
            <svg xmlns="http://www.w3.org/2000/svg" height="20px" viewBox="0 -960 960 960" width="24px" fill="#1f1f1f"><path d="m798-270-60-60q11-27 16.5-52.5T760-436q0-116-82-200t-198-84q-28 0-54 4.5T374-700l-60-60q38-20 79.5-30t86.5-10q74 0 139.5 28T734-694.5Q783-645 811.5-579T840-436q0 45-11 86.5T798-270Zm52-370L680-810l56-56 170 170-56 56ZM820-24 694-150q-45 33-99.5 51.5T480-80q-74 0-139.5-28T226-184q-49-48-77.5-113T120-436q0-62 18.5-116.5T192-652l-34-34-48 48-56-56 48-48-74-74 56-56L876-80l-56 56ZM480-159q42 0 82-13t74-36L248-594q-23 35-35.5 75.5T200-436q0 116 82 196.5T480-159Zm-38-242Zm114-114Z"/></svg>
          </div>`
              : `<div></div>`
          }
          ${
            el.resourceDesc1 || el.resourceDesc2
              ? `<div title='${description}' style="margin-left:auto;">
            <svg xmlns="http://www.w3.org/2000/svg" height="18" viewBox="0 0 24 24" width="18"><path d="M0 0h24v24H0V0z" fill="none"/>
            <path d="M2 12.5C2 9.46 4.46 7 7.5 7H18c2.21 0 4 1.79 4 4s-1.79 4-4 4H9.5C8.12 15 7 13.88 7 12.5S8.12 10 9.5 10H17v2H9.41c-.55 0-.55 1 0 1H18c1.1 0 2-.9 2-2s-.9-2-2-2H7.5C5.57 9 4 10.57 4 12.5S5.57 16 7.5 16H17v2H7.5C4.46 18 2 15.54 2 12.5z"/>
            </svg>
          </div>`
              : `<div></div>`
          }
        </div>
      </div>`;
      obj.includeInBillableHoursTF = el.includeInBillableHoursTF;
      return obj;
    });
    scheduler.updateCollection('sections', this.technician);
  }

  addPlugins() {
    scheduler.plugins({
      timeline: true,
      treetimeline: true,
      editors: true,
      tooltip: true,
      limit: true,
      multiselect: true,
      multisection: true,
      collision: true,
      readonly: true,
    });
  }
  addConfig() {
    //=========================================================================================
    // config
    //=========================================================================================
    scheduler.config.details_on_create = true;
    scheduler.config.details_on_dblclick = true;
    scheduler.config.buttons_right = ['dhx_delete_btn'];
    scheduler.config.multisection = true;
    scheduler.config.show_loading = true;
    scheduler.config.mark_now = false;
    scheduler.config.drag_resize = false;
    scheduler.xy.scale_height = 80;
    scheduler.config.dblclick_create = false;
  }
  addLabels() {
    //=========================================================================================
    //scheduler.locale.labels
    //=========================================================================================
    //-----------------------------------
    //main
    //------------------------------------
    scheduler.locale.labels['timeline_tab'] = 'Timeline';
    scheduler.locale.labels['section_custom'] = 'Section';
    scheduler.locale.labels['unit_tab'] = 'Unit';
    //-----------------------------------
    //Common lighbox labels
    //-----------------------------------
    scheduler.locale.labels['section_customer'] = 'Customer :';
    scheduler.locale.labels['section_order'] = 'Order :';
    scheduler.locale.labels['section_vehicle'] = 'Vehicle :';
    scheduler.locale.labels['copy_button'] = 'Copy';
    scheduler.locale.labels['section_allocatedHours'] = 'Allocated Hours :';
    scheduler.locale.labels['section_extraHours'] = 'Extra Hrs:';
    scheduler.locale.labels['section_groupName'] = 'Group Name:';
    scheduler.locale.labels['section_attachment'] = 'Attachments';
    // scheduler.locale.labels['section_wholeDayWorkYN'] = 'Whole Day';
    //-----------------------------------
    //Unallocated order lighbox labels
    //-----------------------------------

    scheduler.locale.labels['dhx_save_btn'] = 'SAVE';
    scheduler.locale.labels['dhx_cancel_btn'] = 'CANCEL';
    //-----------------------------------
    //Allocated order lighbox labels
    //-----------------------------------
    scheduler.locale.labels['section_technician'] = 'Technician';
    scheduler.locale.labels['section_technicianSelect'] = 'Select More Technician';
  }

  addEventBar() {
    //=========================================================================================
    //Custom Formatting Event Bar
    //=========================================================================================
    const resize_date_format = scheduler.date.date_to_str(scheduler.config.hour_date);

    scheduler.templates.event_bar_text = function (start, end, event) {
      if (event.info === 'info') {
        const availableHrs = event.text.split('|')[0].trim();
        const bookedHrs = event.text.split('|')[1].trim();
        let resourceHrs = '';
        if (event.section_id === 1) {
          resourceHrs = event.text.split('|')[2].trim();
        }
        return `
          <span style="
            position: absolute; 
            top: 0; 
            bottom: 0; 
            width: ${2 * scheduler._cols[0] * 1}px; 
             ${event.section_id === 1 ? 'background: lightblue' : 'background:  #eef0f1ff'};
           
            right: 0; 
            z-index: -1; 
            height: 100%;
            ${event.section_id === 1 ? 'border-bottom: 2px solid #84c5faff;' : 'border-bottom: 2px solid #aaabacff;'}
            border-radius: 6px;
            margin-left: -12px;
            margin-right: -14px;
          "></span>
          <div style="
            position: absolute;
            left: 16px;
            top: 50%;
            transform: translateY(-50%);
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            display: flex;
            justify-content: space-between;
            align-items: center;
            max-width: calc(100% - 32px);
            color: #37474f;
            font-size: 15px;
            font-family: 'Segoe UI', Arial, sans-serif;
            padding: 2px 0;
            width: 95%;
            cursor: default;
          ">
            <div style="flex: 1; text-align: left;">
              <span style="font-weight: 400;  ${event.section_id !== 1 ? 'color: #388e3c; font-weight:600' : 'font-weight:600'}  ">Available:</span> 
              <span style="font-weight: 500;">${availableHrs} hrs </span>
            </div>
           
            <div style="flex: 1; text-align: right;">
           <span style="font-weight: 400;  ${event.section_id !== 1 ? 'color: #d32f2f;font-weight:600' : 'font-weight:600'}  ">Booked:</span> 
              <span style="font-weight: 500;">${bookedHrs} hrs</span>
            </div>
          </div>
        `;
      } else {
        return `
             <span style="position: absolute; top: 0; bottom: 0; width:${
               2 * scheduler._cols[0] * 1
             }px; background-color:lightgrey; right: 0; z-index: -1; height: 100%;
             background-color:  #${event?.data?.BackgroundColour};

              border-top: 3px solid #${event?.data?.BorderColour};"></span>
            <div style="
            position: absolute;
            left: 10px;
            top: 50%;
            transform: translateY(-50%);
            white-space: normal;
            overflow: hidden;
            text-overflow: ellipsis;
            display: flex;
            justify-content: space-between;
            align-items: center;
            max-width: calc(100% - 10px);
            background-color:  #${event?.data?.BackgroundColour};
            padding-top:2px;
            width: 95%;
            display: -webkit-box;
               -webkit-line-clamp: 3;
               -webkit-box-orient: vertical;
          
            ">
            <div style="flex: 1; text-align: left; font-size: 14px;">${event.text}</div>
            </div>`;
      }

      //  else {
      //   return `<div style="position: relative;
      //       border-top: 3px solid;
      //       border-color:#${event?.data?.BorderColour};
      //       padding: 0px;
      //       width:${1 * scheduler._cols[0] * (event?.data?.ScheduledHours < 1 ? 1 : event?.data?.ScheduledHours)}px;
      //       height: 100%;
      //       overflow: hidden;
      //       z-index: -1;
      //       margin-left:-12px;
      //       margin-right:-14px
      //       ">
      //         <div style="position: absolute;
      //         top: 0;
      //         bottom: 0;
      //         width:${1 * scheduler._cols[0] * (event?.data?.ScheduledHours < 1 ? 1 : event?.data?.ScheduledHours)}px;
      //         background-color: #${event?.data?.BackgroundColour};
      //         height: 100%;
      //       ">
      //         </div>

      //         <div style="position: absolute;
      //         left: 10px;
      //         top: 50%;
      //         transform: translateY(-50%);
      //         white-space: normal;
      //         overflow: hidden;
      //         text-overflow: ellipsis;
      //         display: -webkit-box;
      //         -webkit-line-clamp: 3;
      //         -webkit-box-orient: vertical;
      //         max-width: calc(100% - 60px);
      //         ">
      //         <div>aa${event?.text}</div>
      //         </div>
      //         <div style="position: absolute;
      //         right: 0px;
      //         top: 50%;
      //         transform: translateY(-50%);
      //         white-space: nowrap;
      //         ">
      //     ${event?.data?.JobSplitText ? event?.data?.JobSplitText + '&nbsp;&nbsp;' : ''}
      //         </div>
      //       </div>`;
      // }
    };
  }
  addLightBox() {
    //=========================================================================================
    //Common Event Ligthbox setup
    //=========================================================================================

    this.eventViewLightbox = [
      {
        name: 'Type',
        type: 'select',
        options: scheduler.serverList('listworkshopTasks', this.listWorkshopTasks),
        map_to: 'key',
      },

      { name: 'description', height: 50, map_to: 'text', type: 'textarea', focus: true },
      {
        name: 'technician',
        height: 250,
        width: 100,
        type: 'multiselect',
        options: scheduler.serverList('technician'),
        map_to: 'technician_id',
        vertical: true,
      },

      {
        name: 'Other Resources',
        height: 250,
        width: 100,
        type: 'multiselect',
        options: scheduler.serverList('otherResources'),
        map_to: 'otherResources_id',
        vertical: true,
      },
      { name: 'time', height: 72, type: 'time', map_to: 'auto' },

      // { name: 'wholeDayWorkYN', map_to: 'single_checkbox', type: 'checkbox', checked_value: 'wholeDay', height: 40 },
    ];

    //=========================================================================================
    //Order Event Ligthbox setup
    //=========================================================================================
    this.orderViewLightbox = [
      { name: 'order', height: 20, type: 'template', map_to: 'orderNumber', id: 'orderNumber' },
      { name: 'customer', height: 20, type: 'template', map_to: 'customer' },
      { name: 'vehicle', height: 20, type: 'template', map_to: 'vehicle' },
      {
        name: 'Job Type',
        type: 'select',
        options: scheduler.serverList('listworkshopJobTypes', this.listWorkshopJobTypes),
        map_to: 'key',
      },
      { name: 'description', height: 40, map_to: 'description', type: 'textarea', focus: false },
      {
        name: 'technician',
        height: 350,
        width: 100,
        type: 'multiselect',
        options: scheduler.serverList('technician'),
        map_to: 'technician_id',
        vertical: true,
      },
      {
        name: 'Other Resources',
        height: 250,
        width: 100,
        type: 'multiselect',
        options: scheduler.serverList('otherResources'),
        map_to: 'otherResources_id',
        vertical: true,
      },
      { name: 'time', height: 72, type: 'time', map_to: 'auto' },
      { name: 'allocatedHours', height: 20, type: 'template', map_to: 'allocatedHours' },
      { name: 'extraHours', height: 20, type: 'template', map_to: 'extraHours' },
      { name: 'attachment', height: 60, type: 'template', map_to: 'my_templete' },
    ];
  }
  addworkshopSchedulerEventWeeklyView(context) {
    let parent_select_options = scheduler.serverList('technician');
    let child_select_options = { '0000': scheduler.serverList('technician') };
    let update_select_options = function (select, options) {
      // helper function
      if (options) {
        for (let i = 0; i < options.length; i++) {
          select.section.options[i] = new Option(options[i].key, options[i].label);
        }
      }
    };
    // let parent_select_options2 = scheduler.serverList('otherResources');
    // let child_select_options2 = { '0000': scheduler.serverList('otherResources') };
    // let update_select_options2 = function (select, options) {
    //   // helper function
    //   if (options) {
    //     for (let i = 0; i < options.length; i++) {
    //       select.section.options[i] = new Option(options[i].key, options[i].label);
    //     }
    //   }
    // };

    scheduler.attachEvent('onLightboxButton', function (button_id, node, e) {
      if (button_id === 'copy_button') {
        scheduler.endLightbox(false);
        this.btn_copyEvent(button_id, node, e);
      }
    });

    // check if the event collison
    scheduler.attachEvent(
      'onEventCollision',
      (ev, evs) => {
        if (ev.section_id.toString().split(',').length > 1) {
          return false;
        }
        if (allUnallocateSectionID.some((el) => el === ev.section_id) === true) {
          return false;
        } else if (ev?.section_id > 1) {
          scheduler.clearGreyOut();

          return false;
        } else {
          this.isEventCollision = true;
          return true;
        }
      },
      {}
    );
    scheduler.attachEvent('onBeforeLightbox', function (event_id) {
      //check the event section id
      const ev = scheduler.getEvent(event_id);
      var elements = document.querySelectorAll('[data-section-id]');

      elements.forEach(function (element) {
        // Get the value of data-section-id
        var sectionId = element.getAttribute('data-section-id');
        if (sectionId !== String(1)) {
          element.classList.remove('grey-out');
        }
      });
      scheduler.setNavStatus(true);
      scheduler.resetLightbox();
      scheduler.config.event_duration = ev.data?.StandardFitHours * 60;
      scheduler.config.auto_end_date = true;
      const resourceAssigned = ev?.data?.ResourceAssigned.map((el) => el.ResourceID).join(',');
      ev.technician_id = resourceAssigned ?? ev.section_id;
      ev.otherResources_id = resourceAssigned ?? ev.section_id;

      if (!ev.child_id) {
        let parent_id = ev.parent_id || parent_select_options[0]?.key;
        let new_child_options = child_select_options[parent_id];
        update_select_options(scheduler.formSection('child'), new_child_options);
        // let parent_id2 = ev.parent_id || parent_select_options2[0]?.key;
        // let new_child_options2 = child_select_options2[parent_id2];
        // update_select_options2(scheduler.formSection('child'), new_child_options2);
      }
      if (ev?.keyCode || ev?.text === 'New event' || ev?.data?.OrderNumber === 0) {
        //treat as event
        scheduler.btn_openTaskDetailCard(ev);
        return false;
      } else if ((allUnallocateSectionID.some((el) => el === ev.section_id) || ev?.data?.OrderNumber) && (ev?.text !== 'New event' || !ev?.keyCode)) {
        scheduler.btn_openOrderDetailCard(ev);
      }
      return false;
    });

    scheduler.attachEvent('onLightbox', function (ev) {
      const order = scheduler.formSection('order');
      const time = scheduler.formSection('time');
      const allocatedHours = scheduler.formSection('allocatedHours');
      const extraHours = scheduler.formSection('extraHours');
      const selects = time.node.getElementsByTagName('select');
      for (let i = 0; i < selects.length; i++) {
        selects[i].onchange = function () {
          const addedHours = Math.abs(time?.getValue()?.end_date?.getTime() - time?.getValue()?.start_date?.getTime()) / 3600000;
          if (allocatedHours?.getValue() < addedHours) {
            extraHours?.setValue(addedHours - allocatedHours?.getValue());
          } else {
            extraHours?.setValue(0);
          }
        };
      }
    });

    scheduler.attachEvent('onBeforeViewChange', function (old_mode, old_date, mode, date) {
      if (mode == 'Settings') {
        scheduler.alert({
          text: '',
          title: 'Custom setting needs more work',
          ok: 'OK',
          callback: function () {},
        });

        return false; // prevent view change on custom button click
      } else {
        this.btn_Clicked_onBeforeViewChange(old_date, date);
        return true;
      }
    });

    // scheduler.attachEvent('onClick', function (id) {
    //   let event = scheduler.getEvent(id);
    //   if (event.important) scheduler.config.icons_select = ['icon_details'];
    //   else scheduler.config.icons_select = ['icon_details', 'icon_delete'];

    //   return true;
    // });

    //=========================================================================================
    //adding save event
    //=========================================================================================
    scheduler.attachEvent('onEventSave', function (id, ev, is_new) {
      let valid = true;
      const listworkshopTask = context?.listWorkshopTasks.find((el) => el?.key === ev.key);
      ev.keyCode = listworkshopTask?.keyCode;
      let combinedResources;
      if (ev.technician_id && ev.otherResources_id) {
        combinedResources = ev.technician_id + ',' + ev.otherResources_id;
      } else if (ev.technician_id) {
        combinedResources = ev.technician_id;
      } else if (ev.otherResources_id) {
        combinedResources = ev.otherResources_id;
      }
      if (is_new) {
        combinedResources ? (ev.section_id = combinedResources) : (valid = false);
        ev.text = listworkshopTask.label + ' : ' + ev.text;
        ev.color = '#' + listworkshopTask.backgroundColourCode;
        ev.scheduledHours = context.newScheduledHrs;
        if (!valid) {
          !ev.text ? scheduler.alert('Description must not be empty') : null;
          !combinedResources ? scheduler.alert('Technician must not be empty') : null;
        }
      } else if (ev.text && ev?.keyCode) {
        ev.scheduledHours = context.newScheduledHrs;
        combinedResources ? (ev.section_id = combinedResources) : (valid = false);
      }
      const selectedStartTime = moment(ev.start_date).format('HH:mm');
      const startRangeTime = moment(getformatedTime(context.globalStart.toString()), 'HH:mm');
      let diffStartHours = moment.duration(moment(selectedStartTime, 'HH:mm:ss').diff(moment(startRangeTime, 'HH:mm:ss'))).hours();
      let diffStartMinutes = moment.duration(moment(selectedStartTime, 'HH:mm:ss').diff(moment(startRangeTime, 'HH:mm:ss'))).minutes();
      let diffTotalStart = diffStartHours + diffStartMinutes / 60;
      const selectedEndTime = moment(ev.end_date).format('HH:mm');
      const endRangeTime = moment(getformatedTime(context.globalEnd.toString()), 'HH:mm');
      let diffEndHours = moment.duration(moment(selectedEndTime, 'HH:mm:ss').diff(moment(endRangeTime, 'HH:mm:ss'))).hours();
      let diffEndMinutes = moment.duration(moment(selectedEndTime, 'HH:mm:ss').diff(moment(endRangeTime, 'HH:mm:ss'))).minutes();
      let diffTotalEnd = diffEndHours + diffEndMinutes / 60;
      if (moment(ev.start_date).format('HH:mm') === '00:00' && moment(ev.start_date).format('HH:mm') === '00:00') {
        ev.start_date = moment(getformatedDate(context.currentDate) + ' ' + getformatedTimeHHMM(context.globalStart.toString())).toDate();
        ev.end_date = moment(getformatedDate(context.currentDate) + ' ' + getformatedTimeHHMM(context.globalEnd.toString())).toDate();
        context.newScheduledHrs = moment.duration(moment(ev.end_date, 'HH:mm').diff(moment(ev.start_date, 'HH:mm'))).asHours();
      } else if (diffTotalStart < 0) {
        // when start time < global start time
        valid = false;
        scheduler.alert('Selected start time exceed working hours of the day');
      } else if (diffTotalEnd > 0) {
        scheduler.alert('Selected end time exceed working hours of the day');
        valid = false;
      } else if (!is_new && ev?.technician_id) {
        const currentOrderData = context.orderArray.filter((el) => el.OrderNumber === Number(ev?.orderNumber));
        context.newScheduledHrs = currentOrderData[0]?.ScheduledHours;
        ev.scheduledHours = currentOrderData[0]?.ScheduledHours;
      }
      if (ev.description && !ev?.keyCode) {
        combinedResources ? (ev.section_id = combinedResources) : (valid = false);
      }
      if (!valid) {
        return false;
      } else {
        return true;
      }
    });

    scheduler.attachEvent('onBeforeEventDelete', function (id, ev) {
      if (ev?.data?.OrderNumber > 0) {
        scheduler.alert({
          text: '',
          title: 'Order not allowed to Delete',
          ok: 'OK',
          callback: function () {},
        });
        return false;
      }
      return true;
    });
    //=========================================================================================
    //Triggering method before event change
    //=========================================================================================

    scheduler.attachEvent('onBeforeEventChanged', function (ev, e, is_new, original) {
      if (ev.section_id !== 1 || is_new) {
        scheduler.alert({
          text: 'On Weekly screen view, you can only unallocate job or move between unallocate to unallocate section.',
          title: 'ERROR!',
        });
        return false;
      }
      if (ev.data?.StatusGroup !== 'TASK') {
        const tempResource = ev.section_id;
        const startDate = moment(ev.start_date).format('YYYY-MM-DD') + ' ' + '00:00';
        const endDate = moment(ev.end_date).format('YYYY-MM-DD') + ' ' + '00:00';
        ev.start_date = startDate;
        ev.end_date = endDate;
        // context.newScheduledHrs = moment.duration(moment(ev.end_date).diff(moment(ev.start_date))).asHours();
        // ev.data['ScheduledHours'] = context.newScheduledHrs;
        context.updateOrder(ev, tempResource, context);
      }
    });

    scheduler.attachEvent('onAfterLightbox', function () {
      scheduler.setNavStatus(false);
    });

    //-----------------------------------------------------------------------------
    //onContextMenu /Right Click
    //hide the calander
    //add menu div for right click
    //on scroll hide the menu
    //if right click without id return false
    //if right click on task return false
    //remove current menu div if on right click to different order
    //---------------------------------------------------------------------------
    scheduler.attachEvent('onContextMenu', function (id, e) {
      if (!id) {
        return;
      }
      let tooltip = scheduler.ext.tooltips.tooltip;
      if (tooltip) {
        tooltip.hide();
      }
      const screenHeight = document.documentElement.scrollHeight;
      const screenWidth = document.documentElement.scrollWidth;
      const positionCursorY = screenHeight - e.clientY < 210 ? e.clientY - (210 - (screenHeight - e.clientY)) : e.clientY;
      const positionCursorX = screenWidth - e.clientX < 200 ? e.clientX - (200 - (screenWidth - e.clientX)) : e.clientX;
      context.showingContextMenu = true;
      scheduler.removeContextMenu();
      let section = scheduler.matrix.timeline.y_unit[scheduler._locate_cell_timeline(e).y];
      if (scheduler._locate_cell_timeline(e)) {
        if (scheduler._locate_cell_timeline(e).x === -1) {
          if (context.technician.some((el) => el.resourceID === section.key)) {
            scheduler.setNavStatus(true);
            document.querySelector('.dhx_cal_container')?.setAttribute('style', 'opacity:.7');
            const contextMenu = `
                <div 
                  style="top: ${positionCursorY}px;left: ${positionCursorX}px; display: grid; background:white; padding-bottom:30px; width:200px"
                  class='custom_menu'
                  onclick="scheduler.removeContextMenu()"
                >
                  <div style='display:flex; flex-direction:column; text-align:center'>
                    <input type=button value="Delete" onclick=""/ > 
                    <input type=button value="Edit" onclick=""/ > 
                  </div>
                  <div style='display:flex; flex-direction:column; background:red; text-align:center; color:white'>
                  CANCEL
                  </div>
                </div>
             `;
            //this.scheduler.tooltip.hide();
            const el = document.createElement('div');
            el.innerHTML = contextMenu;
            document.body.appendChild(el);
          }
        }
      }
      const ev = scheduler.getEvent(id);
      if (!ev?.keyCode && section.label === '' && ev?.data?.OrderNumber === 0) {
        scheduler.setNavStatus(true);
        document.querySelector('.dhx_cal_container')?.setAttribute('style', 'opacity:.7');
        const order = ev.data.OrderType.toString();
        let listOrderMenu = '';
        for (let i = 0; i < context.listWorkshopVehicleStatus?.length; i++) {
          if (ev.data?.VehicleStatusCode !== context?.listWorkshopVehicleStatus[i]?.code) {
            listOrderMenu =
              listOrderMenu +
              `<input type=button value="` +
              context.listWorkshopVehicleStatus[i]?.shortDescription +
              `" 
              onclick="scheduler.customUpdateOrder({},${id},${context.listWorkshopVehicleStatus[i]?.code.toString()})"/>`;
          }
        }
        const contextMenu = `
            <div 
              style="top: ${positionCursorY}px;left: ${positionCursorX}px; display: grid; background-color:transparent; padding-bottom:30px; width:200px"
              class='custom_menu'
              onclick="scheduler.removeContextMenu()"
            >
              <div style='display:flex; flex-direction:column; text-align:center; background:grey;'>
                Update Order
                ${listOrderMenu}
                <input type=button value="Split" onclick="scheduler.customSplitOrder(${ev?.data.JobID})"/>
               ${
                 ev?.data?.OtherScheduledSplitsYN === 'Y' && ev?.data?.OtherUnScheduledSplitsYN === 'N'
                   ? `<input type=button value="Consolidate Including Scheduled" onclick="scheduler.forceUnallocateTF(${ev?.data.JobID})"/>`
                   : ev?.data?.OtherScheduledSplitsYN === 'Y' && ev?.data?.OtherUnScheduledSplitsYN === 'Y'
                   ? `<input type=button value="Consolidate Including Scheduled" onclick="scheduler.forceUnallocateTF(${ev?.data.JobID})"/>
                   <input type=button value="Consolidate Excluding Scheduled" onclick="scheduler.customConsolidateOrder(${ev?.data.JobID})"/>`
                   : ev?.data?.OtherUnScheduledSplitsYN === 'Y'
                   ? `<input type=button value="Consolidate" onclick="scheduler.customConsolidateOrder(${ev?.data.JobID})"/>`
                   : ''
               }
               ${
                 ev?.data?.ValidSO === 'N'
                   ? `</div>
              <input type=button value="DELETE" 
              onclick="scheduler.customUpdateOrder({},${id},'DELETE')"/>`
                   : ``
               }
              <div style='display:flex; flex-direction:column; background:red; text-align:center; color:white'>
              CANCEL
              </div>
            </div>
         `;
        const el = document.createElement('div');
        el.innerHTML = contextMenu;
        document.body.appendChild(el);
      } else if (!ev?.keyCode && ev?.data?.OrderNumber && ev?.data?.OrderNumber > 0) {
        scheduler.setNavStatus(true);
        document.querySelector('.dhx_cal_container')?.setAttribute('style', 'opacity:.7');

        let list = '';
        for (let i = 0; i < context.listWorkshopVehicleStatus?.length; i++) {
          if (ev.data?.VehicleStatusCode !== context?.listWorkshopVehicleStatus[i]?.code) {
            list =
              list +
              `<input type=button value="` +
              context.listWorkshopVehicleStatus[i]?.shortDescription +
              `" 
              onclick="scheduler.customUpdateOrder({},${id},${context.listWorkshopVehicleStatus[i]?.code})"/>`;
          }
        }
        const contextMenu = `
            <div 
              style="top: ${positionCursorY}px;left: ${positionCursorX}px; display: grid; background:white; background-color:transparent, padding-bottom:10px"
              class='custom_menu'
              onclick="scheduler.removeContextMenu()"
            >
              <div style='display:flex; flex-direction:column; text-align:center; background:grey;  padding-top:10px'>
                Update Status 
             ${list}
              
              </div>  
             
              <div style='display:flex; flex-direction:column; background:red; text-align:center; color:white'>
              CANCEL
              </div>
            </div>
         `;
        const el = document.createElement('div');
        el.innerHTML = contextMenu;
        document.body.appendChild(el);
      } else if (ev?.data?.StatusGroup === 'TASK') {
        const positionCursorY = screenHeight - e.clientY < 150 ? e.clientY - (150 - (screenHeight - e.clientY)) : e.clientY;
        const positionCursorX = screenWidth - e.clientX < 200 ? e.clientX - (200 - (screenWidth - e.clientX)) : e.clientX;

        scheduler.setNavStatus(true);
        document.querySelector('.dhx_cal_container')?.setAttribute('style', 'opacity:.7');
        const contextMenu = `
          <div 
          style="top: ${positionCursorY}px;left: ${positionCursorX}px; display: grid; background-color:transparent; padding-bottom:30px; width:200px"
          class='custom_menu'
          onclick="scheduler.removeContextMenu()"
        >
          <div style='display:flex; flex-direction:column; text-align:center; background:grey;'>
            Update Task
            <input type=button value="Delete Task" onclick="scheduler.customCreateOrUpdateEvent({},${id},'delete')"/>
           
          </div>
          <div style='display:flex; flex-direction:column; background:red; text-align:center; color:white'>
          CANCEL
          </div>
        </div>
         `;
        const el = document.createElement('div');
        el.innerHTML = contextMenu;
        document.body.appendChild(el);
      }
    });
    scheduler.attachEvent('onAfterFolderToggle', function (section, isOpen, allSections) {
      if (section?.key === schedulerAppValue.unAllocatedFloater_SectionId) {
        if (isOpen) {
          context.floaterToggleState = true;
        } else {
          context.floaterToggleState = false;
        }
      }
      if (section?.key === schedulerAppValue.unAllocatedSalesOrder_SectionId) {
        if (isOpen) {
          context.salesTogglestate = true;
        } else {
          context.salesTogglestate = false;
        }
      }
    });
  }

  addCustomWorkshopSchedulerEventWeeklyView(context: any) {
    context.customFunctionLoaded = true;
    const element = document.querySelector('.dhx_cal_data');
    element.addEventListener('scroll', (event) => {
      scheduler.removeContextMenu();
    });
    scheduler.btn_Clicked_onBeforeViewChange = (old_date, date) => {
      const old_datef = old_date?.toLocaleDateString('it-IT');
      const datef = date?.toLocaleDateString('it-IT');
      if (old_date && old_datef !== datef) {
        scheduler.clearAll();
        this.adjustedCurrentDate = moment(date).subtract(1, 'days').format('DD/MM/YYYY');
        this.year = Number(datef.split('/')[2]);
        this.month = Number(datef.split('/')[1]);
        this.day = Number(datef.split('/')[0]);
        this.router.navigate(['/pos/scheduler/' + this.day + '/' + this.month + '/' + this.year + '/week']);

        this.initializeWeekView();
      }
    };

    scheduler.btn_splitOrder = (jobID) => {
      this.splitOrder(jobID);
    };

    scheduler.btn_consolidateOrder = (jobID) => {
      this.consolidateOrder(jobID, false);
    };
    scheduler.btn_currentEventData = (data: any) => {
      this.currentEventData = data;
    };

    scheduler.btn_openOrderDetailCard = (data: any) => {
      if (!this.orderDetailCardLoaded) {
        this.orderDetailCardLoaded = true;
        this.currentEventData = data;
        context.orderDetailCard();
      }
    };
    scheduler.btn_openTaskDetailCard = (data: any) => {
      if (!this.taskDetailCardLoaded) {
        this.taskDetailCardLoaded = true;
        this.currentTaskData = data;
        context.taskDetailCard();
      }
    };
    scheduler.btn_orderNumberClick = (data) => {
      this.fetchOrderFromJDE();
    };
    scheduler.getTechnician = () => {
      return context.technician;
    };
    scheduler.getOtherResources = () => {
      return context.otherResources;
    };
    scheduler.getScheduledHrs = (start, end) => {
      return moment.duration(moment(end, 'HH:mm:ss').diff(moment(start, 'HH:mm:ss'))).asHours();
    };

    //dp. api action
    scheduler.customCreateOrUpdateEvent = (data, id, state) => {
      if (id > 0 && state === 'delete') {
        const ev = scheduler.getEvent(id);
        const resourceList = ev?.data?.ResourceAssigned.filter((el) => el.ResourceID !== ev?.section_id).map((data) => {
          return { resourceID: data.ResourceID, allocationTypeCode: data.AllocationTypeCode, allocationPercentage: data.AllocationPercentage };
        });
        const eventDataToUpdate = {
          branch: context.defaultBranch,
          jobID: ev?.data?.JobID,
          scheduledHours: ev?.data?.ScheduledHours,
          description: ev?.data.Description,
          resources: resourceList,
          startTime: ev?.data?.WorkshopStartTime,
          endTime: ev?.data?.WorkshopEndTime,
          startDate: ev?.data?.WorkshopStartDate ?? moment(ev?.start_date).format('DD/MM/YYYY'),
          endDate: ev?.data?.WorkshopEndDate ?? moment(ev?.end_date).format('DD/MM/YYYY'),
          taskCode: ev?.data?.TaskCode,
        };
        this.eventService.update(eventDataToUpdate).then((data) => {
          if (data) {
            context.reloadRecords();
          }
        });
      } else {
        this.eventService.insert(data).then((val) => {
          context.reloadRecords();
          return val;
        });
      }
    };
    scheduler.customDeleteEvent = (id, data) => {
      this.eventService.remove(data);
    };

    scheduler.customUpdateOrder = (data = {}, id = 0, state) => {
      if (id > 0) {
        const ev = scheduler.getEvent(id);
        if (state === 'DELETE') {
          scheduler.confirm({
            text: 'This action will delete this job permamently from scheduler. Are you sure?',
            ok: 'Yes',
            cancel: 'No',
            callback: function (result) {
              if (result) {
                context.removeOrderFromSchedule(ev?.data?.JobID).then((data) => {
                  if (data) {
                    context.reloadRecords();
                  }
                });
              } else {
              }
            },
          });
        } else if (state === 'UNALLOCATE') {
          const resourceList = ev?.data?.ResourceAssigned.filter((el) => el.ResourceID !== ev?.section_id).map((data) => {
            return { resourceID: data.ResourceID, allocationTypeCode: data.AllocationTypeCode, allocationPercentage: data.AllocationPercentage };
          });
          const orderDataToUpdate = {
            branch: context.defaultBranch,
            jobID: ev?.data?.JobID,
            scheduledHours: ev?.data?.ScheduledHours,
            orderNumber: ev?.data?.OrderNumber,
            orderType: ev?.data?.OrderType,
            description: ev?.data.Description,
            resources: resourceList,
            startTime: ev?.data?.WorkshopStartTime,
            endTime: ev?.data?.WorkshopEndTime,
            startDate: ev?.data?.WorkshopStartDate ?? moment(ev?.start_date).format('DD/MM/YYYY'),
            endDate: ev?.data?.WorkshopEndDate ?? moment(ev?.end_date).format('DD/MM/YYYY'),
            jobTypeCode: ev?.data?.JobTypeCode ?? '',
            vehicleStatusCode: ev?.data?.VehicleStatusCode,
            jobOwner: ev?.data?.JobOwner ?? '',
          };
          this.eventService.maintainOrderBooking(orderDataToUpdate).then((data) => {
            if (data) {
              context.reloadRecords();
            }
          });
        } else if (state === 'SCHEDULE_FOR_TOMORROW') {
          const resourceList = ev?.data?.ResourceAssigned.filter((el) => el.ResourceID === ev?.section_id).map((data) => {
            return { resourceID: data.ResourceID, allocationTypeCode: data.AllocationTypeCode, allocationPercentage: data.AllocationPercentage };
          });
          const orderDataToUpdate = {
            branch: context.defaultBranch,
            jobID: ev?.data?.JobID,
            scheduledHours: 0,
            orderNumber: ev?.data?.OrderNumber,
            orderType: ev?.data?.OrderType,
            description: ev?.data.Description,
            resources: resourceList,
            startTime: 0,
            endTime: 0,
            startDate: context.nextGlobalDate ?? moment(ev?.start_date).add(1, 'days').format('DD/MM/YYYY'),
            endDate: context.nextGlobalDate ?? moment(ev?.end_date).add(1, 'days').format('DD/MM/YYYY'),
            jobTypeCode: ev?.data?.JobTypeCode ?? '',
            vehicleStatusCode: ev?.data?.VehicleStatusCode,
            jobOwner: ev?.data?.JobOwner ?? '',
          };
          this.eventService.maintainOrderBooking(orderDataToUpdate).then((data) => {
            if (data) {
              context.reloadRecords();
            }
          });
        } else {
          console.log('start date', moment(ev?.start_date).format('DD/MM/YYYY'));
          const resourceList = ev?.data?.ResourceAssigned.map((el) => {
            return { resourceID: el.ResourceID, allocationTypeCode: el.AllocationTypeCode, allocationPercentage: el.AllocationPercentage };
          });
          const orderDataToUpdate = {
            branch: context.defaultBranch,
            jobID: ev?.data?.JobID,
            scheduledHours: ev.data?.ScheduledHours,
            orderNumber: ev?.data?.OrderNumber,
            orderType: ev?.data?.OrderType,
            description: ev?.data.Description,
            resources: resourceList,
            startTime: ev?.data?.WorkshopStartTime,
            endTime: ev?.data?.WorkshopEndTime,
            startDate: ev?.data?.WorkshopStartDate ?? moment(ev?.start_date).format('DD/MM/YYYY'),
            endDate: ev?.data?.WorkshopEndDate ?? moment(ev?.end_date).format('DD/MM/YYYY'),
            jobTypeCode: ev?.data?.JobTypeCode ?? '',
            vehicleStatusCode: state === 0 ? '00' : state?.toString(),
            jobOwner: ev?.data?.JobOwner ?? '',
          };
          if (state === 10) {
            this.sendSMSReminder(false, ev?.data?.JobID, orderDataToUpdate);
          } else if (state === 30) {
            this.sendSMSCollectCar(ev?.data?.JobID, orderDataToUpdate);
          } else {
            this.eventService.maintainOrderBooking(orderDataToUpdate).then((data) => {
              if (data) {
                context.reloadRecords();
              }
            });
          }
        }
      } else {
        this.eventService.maintainOrderBooking(data).then((data) => {
          if (data) {
            context.reloadRecords();
          }
        });
      }
    };

    scheduler.customSplitOrder = (jobID) => {
      this.splitOrder(jobID);
    };
    scheduler.customConsolidateOrder = (jobID) => {
      this.consolidateOrder(jobID, false);
    };
    scheduler.forceUnallocateTF = (jobID) => {
      scheduler.confirm({
        title: 'Confirm',
        text: 'Are you sure you want to remove from the schedule existing order splits and consolidate them into this unallocated order?',
        ok: 'Ok',
        cancel: 'Cancel',
        callback: function (result) {
          if (result) {
            context.consolidateOrder(jobID, true);
          }
        },
      });
    };

    scheduler.setNavStatus = (value) => {
      this.eventService.navDisable = value;
    };

    scheduler.removeContextMenu = () => {
      const el = document.querySelector('.custom_menu');
      if (el) {
        el.innerHTML = null;
        el.remove();
        scheduler.setNavStatus(false);
        document.querySelector('.dhx_cal_container')?.setAttribute('style', 'opacity:');
      }
    };

    scheduler.showSpinner = () => {
      if (scheduler.config.show_loading) {
        let spin;
        spin = document.createElement('div');
        spin.className = 'dhx_loading';
        spin.style.left = Math.round((scheduler._x - 128) / 2) + 'px';
        spin.style.top = Math.round((scheduler._y - 15) / 2) + 'px';
        scheduler._obj.appendChild(spin);
      }
    };

    scheduler.hideSpinner = () => {
      let spin = document.createElement('div');
      if (spin && typeof spin == 'object') {
        if (spin.parentNode) {
          spin?.parentNode?.removeChild(spin);
        }
        scheduler.config.show_loading = true;
      }
    };

    scheduler.getResourceList = (resoureList, previousTechnicianIDData) => {
      previousTechnicianIDData;
      const filteredTechnician = previousTechnicianIDData?.data?.ResourceAssigned.filter((el) => {
        return el.ResourceID !== previousTechnicianIDData.section_id;
      });

      let resource = resoureList.map((el) => {
        return { resourceID: el, allocationTypeCode: '', allocationPercentage: 100 };
      });
      filteredTechnician
        ? filteredTechnician?.map((el) =>
            resource.push({ resourceID: el?.ResourceID, allocationTypeCode: el.AllocationTypeCode, allocationPercentage: el.AllocationPercentage })
          )
        : null;
      return resource;
    };

    scheduler.checkCollisionCustom = (startDate, endDate, resourceId) => {
      let count = scheduler.getEvents(startDate, endDate);
      let evsWithSamePerson = count.filter((item) => item.section_id === resourceId);
      if (evsWithSamePerson.length > 1) {
        return true;
      } else {
        return false;
      }
    };

    scheduler.getBarBackgroundColourCode = (statusGroup, code, scheduledTF) => {
      return context.listWorkshopOrderStatus?.filter((el) => el?.statusGroup === statusGroup?.toString() && el?.code === code)[0]
        ?.backgroundColourCode;
    };
    scheduler.confimationDeleteOrder = (dataToDelete) => {
      context.eventService
        .removeResourceFromSchedule(dataToDelete)
        .pipe(takeUntil(this.unSubscribe$))
        .subscribe((data) => {
          if (data) {
            scheduler.alert({
              text: 'Deleted',
              title: 'Message',
              ok: 'OK',
            });
            scheduler.clearAll();
            //context.loadTimelineScheduler(context.currentDate);
          }
        });
    };
    scheduler.customReloadAll = () => {
      scheduler.clearAll();
      this.initializeWeekView();
      //context.loadTimelineScheduler(context.currentDate);
    };
    scheduler.showSectionTooltipTechnician = (index, text) => {
      context.showTooltip(index, text);
    };

    scheduler.hideSectionTooltipTechnician = (index) => {
      context.hideTooltip(index);
    };

    scheduler.showSectionTooltipOtherResource = (index, text) => {
      context.showTooltipOtherResource(index, text);
    };

    scheduler.hideSectionTooltipOtherResource = (index) => {
      context.hideTooltipOtherResource(index);
    };

    scheduler.onDateClick = (dateValue) => {
      context.onDateClick(dateValue);
    };

    scheduler.clearGreyOut = () => {
      context.clearGreyOut();
    };
  }
  addWeeklyView() {
    //=========================================================================================
    //WeeklyView
    const sections = [];
    //=========================================================================================
    scheduler.createTimelineView({
      section_autoheight: false,

      name: 'timeline',
      x_unit: 'day',
      x_date: '%l, %F %d', // e.g., Monday, June 30
      x_step: 1,
      x_size: this.dateArray?.length + this.skipDateCount || 5, // 10 days visible
      x_length: this.dateArray?.length + this.skipDateCount || 5, // show 10 days at a time
      y_unit: scheduler.serverList('sections', []),
      y_property: 'section_id',
      render: 'tree',
      folder_events_available: true,
      dy: 80,
      dx: 160,
      scrollable: true,
      column_width: 324,
      getEventHeight: (event) => {
        // Always return the same height for all events to avoid gaps
        if (event?.info === 'info') {
          return 20;
        } else {
          return 80;
        }
      },

      getEventTop: (event) => {
        const timeline = scheduler.getView();
        const cellStartDate = scheduler.date.date_part(new Date(event.start_date));
        const cellEndDate = scheduler.date.add(scheduler.date.date_part(new Date(event.end_date)), 1, 'day');
        const cellEvents = scheduler.getEvents(cellStartDate, cellEndDate).filter((cellEvent) => {
          return cellEvent[timeline.y_property] == event[timeline.y_property] && cellEvent._sorder < event._sorder && cellEvent.id != event.id;
        });

        const offsetTop = {};
        cellEvents.forEach((cellEvent) => {
          offsetTop[cellEvent._sorder] = Math.max(offsetTop[cellEvent._sorder] || 0, timeline.getEventHeight(cellEvent));
        });

        let eventTop = 2;
        for (const eventRow in offsetTop) {
          eventTop += offsetTop[eventRow] + 2;
        }

        return eventTop;
      },
    });
    scheduler.ignore_timeline = (date) => {
      // If dateArray is defined, always show dates present in dateArray
      if (
        this.dateArray &&
        this.dateArray.some((d) => {
          // d.date is assumed to be in 'DD/MM/YYYY' or similar format
          const [day, month, year] = d.date.split('/').map(Number);
          const dDate = new Date(year, month - 1, day);
          return dDate.getFullYear() === date.getFullYear() && dDate.getMonth() === date.getMonth() && dDate.getDate() === date.getDate();
        })
      ) {
        // If date matches any in dateArray, do not ignore
        return false;
      } else {
        return true;
      }
    };

    scheduler.templates.timeline_scale_date = function (date) {
      // Format date as '%l, %F %d' and add grey background
      const dateValue = moment(date).format('DD/MM/YYYY');
      const formattedDate = scheduler.date.date_to_str('%l, %F %d')(date);
      return `<span style="font-weight:600;font-size:20px;
     
       width:100%; text-align:center; cursor:pointer; color:#1976d2; text-decoration:underline;" 
        onclick="scheduler.onDateClick('${dateValue}')"
        onmouseover="this.style.cursor='pointer'">${formattedDate}</span>`;
    };

    scheduler.templates.timeline_cell_class = function (evs, date, section) {
      //if section id !==1 then add background grey color
      if (section.resourceID !== 1) {
        return 'grey_section';
      }
      return '';
    };

    scheduler.templates.event_class = function (start, end, ev) {
      return '';
    };

    function block_readonly(id) {
      if (!id) return true;
      return !this.getEvent(id).readonly;
    }
    scheduler.attachEvent('onBeforeDrag', block_readonly);
    scheduler.attachEvent('onClick', block_readonly);

    // scheduler.attachEvent('onBeforeDrag', function (id, mode, e) {

    // });

    scheduler.attachEvent('onEventDrag', function (id, mode, e) {
      if (!id) {
        return false;
      }

      // Get the section_id of the event being dragged
      var ev = scheduler.getEvent(id);
      var start = scheduler.getActionData(e).date;
      // Add 30 minutes to start_date using moment and ensure ISO format
      //if ev.end_date is not defined then set it to start_date + 500 minutes
      if (!ev.end_date) {
        ev.end_date = moment(start).add(500, 'minutes').toDate();
      }
      ev.start_date = moment(ev.start_date).add(0, 'minutes').toDate();
      ev.end_date = moment(ev.start_date).add(334, 'minutes').toDate();

      var elements = document.querySelectorAll('[data-section-id]');

      elements.forEach(function (element) {
        // Get the value of data-section-id
        var sectionId = element.getAttribute('data-section-id');
        if (sectionId !== String(1)) {
          element.classList.add('grey-out');
        }
      });
      return true;
    });

    scheduler.attachEvent('onBeforeEventDragIn', function (id, e) {
      //any custom logic here
      return false;
    });
    scheduler.attachEvent('onBeforeEventDragOut', function (id, ev, e) {
      //any custom logic here
      return false;
    });

    scheduler.attachEvent('onDragEnd', function () {
      // Remove grey-out class from all sections
      var sections = document.querySelectorAll('.dhx_cal_data .dhx_cal_event');
      sections.forEach(function (section) {
        section.classList.remove('grey-out');
      });
      return true;
    });

    scheduler.config.lightbox.sections = [
      { name: 'description', height: 130, map_to: 'text', type: 'textarea', focus: true },
      { name: 'custom', height: 23, type: 'select', options: sections, map_to: 'section_ids' },
      { name: 'time', height: 72, type: 'time', map_to: 'auto' },
    ];
    const [dayStr, monthStr, yearStr] = this.currentDate.split('/');
    const monday = new Date(Number(yearStr), Number(monthStr) - 1, Number(dayStr));
    scheduler.init(this.schedulerContainer.nativeElement, monday, 'timeline');
  }

  sendSMSReminder(sendtoAll = false, jobID = 0, orderDataToUpdate) {
    this.confirmationService.confirm({
      message: sendtoAll
        ? 'You are about to send a SMS message to all customers with jobs scheduled to a technican for this date where the vehicle is not already on site. <div style="text-align:center"><p>ARE YOU SURE?</p></div>'
        : 'You are about to send a SMS message to customers',
      key: 'sendSMSConfirmation',
      accept: () => {
        this.eventService
          .sendSMSReminderBeforeBooking({ date: sendtoAll ? this.currentDate : '', jobID: sendtoAll ? 0 : jobID })
          .pipe(takeUntil(this.unSubscribe$))
          .subscribe((data) => {
            if (data?.ErrorFlag === '1' && data?.resultArray.length > 0) {
              let error = '';
              this.confirmationService.confirm({
                message: data?.resultArray.map((el) => (error += el.message + '\n')),
                key: 'sendSMSResult',
                accept: () => {},
              });
            } else if (data?.ErrorFlag === '0') {
              this.confirmationService.confirm({
                message: 'Message sent successfully',
                key: 'sendSMSResult',
                accept: () => {},
              });
              this.eventService.maintainOrderBooking(orderDataToUpdate).then((data) => {
                if (data) {
                  this.reloadRecords();
                }
              });
            }
          });
      },
    });
  }

  sendSMSCollectCar(jobID = 0, orderDataToUpdate) {
    this.confirmationService.confirm({
      message: 'You are about to send collect car SMS message to customer',
      key: 'sendSMSConfirmation',
      accept: () => {
        this.eventService
          .sendSMSCollectCar({ jobID: jobID })
          .pipe(takeUntil(this.unSubscribe$))
          .subscribe((data) => {
            if (data?.ErrorFlag === '1') {
              let error = '';
              this.confirmationService.confirm({
                message: data?.Message ?? data?.resultArray.map((el) => (error += el.message + '\n')),
                key: 'sendSMSResult',
                accept: () => {},
              });
            } else if (data?.ErrorFlag === '0') {
              let error = '';
              this.confirmationService.confirm({
                message: data?.resultArray.map((el) => (error += el.message + '\n')),
                key: 'sendSMSResult',
                accept: () => {},
              });
              this.eventService.maintainOrderBooking(orderDataToUpdate).then((data) => {
                if (data) {
                  this.reloadRecords();
                }
              });
            }
          });
      },
    });
  }

  splitOrder(jobID) {
    const selectedOrder = this.orderArray.filter((el) => el.JobID === jobID)[0];
    this.eventService
      .fetchOrderDetailsForSplit({
        jobID: jobID,
        autoSplitTF: false,
      })
      .pipe(takeUntil(this.unSubscribe$))
      .subscribe((data) => {
        if (data?.ErrorFlag === '0') {
          if (data?.response?.jobGroup) {
            const modalRef2 = this.modalService.open(SplitOrderContent, { size: 'xl', backdrop: 'static' });
            modalRef2.componentInstance.actionSplitOrder = true;
            modalRef2.componentInstance.unAssignedOrdersList = data?.response?.jobGroup;
            modalRef2.componentInstance.orginalUnAssignedOrdersList = data?.response?.jobGroup;
            modalRef2.componentInstance.selectedOrder = selectedOrder;
            modalRef2.componentInstance.currentDate = this.currentDate;
            modalRef2.componentInstance.defaultBranch = this.defaultBranch;
            modalRef2?.result.then((result) => {
              if (result) {
                scheduler.clearAll();
                //this.loadTimelineScheduler(this.currentDate);
              }
            });
          } else {
            scheduler.alert({
              text: 'Cannot perform split',
              title: 'Split Invalid',
              ok: 'Ok',
            });
          }
        }
      });
  }

  consolidateOrder(jobID, forceUnallocateTF) {
    this.eventService
      .consolidateOrderV2({
        jobID: jobID,
        forceUnallocateTF: forceUnallocateTF,
      })
      .pipe(takeUntil(this.unSubscribe$))
      .subscribe((data) => {
        if (data?.ErrorFlag === '0') {
          scheduler.clearAll();
          this.reloadRecords();
        }
      });
  }

  reloadRecords() {
    this.loading.next(true);
    scheduler.clearAll();
    this.getStartDate();
    this.initializeWeekView();
  }

  fetchOrderFromJDE() {
    this.customerStore.dispatch(
      new FetchJdeOrder({
        orderNumber: this.currentEventData?.data?.OrderNumber.toString(),
        orderType: this.currentEventData?.data?.OrderType,
        JDEOrderType: this.currentEventData?.data?.JDEOrderType,
        JDECompany: this.currentEventData?.data?.JDECompany,
      })
    );
  }

  handleCloseModal(event) {
    if (event) {
      this.modalService.dismissAll();
    }
  }

  setWorkshopHour() {
    const modalRef = this.modalService.open(SchedulerSetWorkshopHours, { size: 'xl' });
    modalRef.componentInstance.actionSetWorkshopDay = true;
    modalRef.componentInstance.globalData = this.globalData;
    modalRef.componentInstance.defaultBranch = this.defaultBranch;
    modalRef.componentInstance.currentDate = this.currentDate;
    modalRef?.result.then((result) => {
      if (result) {
        scheduler.customReloadAll();
      }
    });
  }

  resourceRemove() {
    this.eventService
      .fetchScheduledResources({
        branch: this.defaultBranch,
        startDate: convert(scheduler.getState().date),
        endDate: convert(scheduler.getState().date),
      })
      .pipe(takeUntil(this.unSubscribe$))
      .subscribe((data) => {
        if (data?.ErrorFlag === '0') {
          const modalRef = this.modalService.open(NgbdModalResourceContent, { size: 'xl' });
          modalRef.componentInstance.actionRemoveResource = true;
          modalRef.componentInstance.resourceList = data?.resourceList;
          modalRef.componentInstance.currentDate = this.currentDate;
          modalRef.componentInstance.defaultBranch = this.defaultBranch;
          modalRef?.result.then((resultData) => {
            if (resultData) {
              if (resultData?.confirmationRequired) {
                scheduler.confirm({
                  text: `${resultData?.message}`,
                  title: 'Alert',
                  ok: 'CONFIRM',
                  cancel: 'CANCEL',
                  callback: function (result) {
                    if (result) {
                      Object.assign(resultData.dataToRemoveResource, { confirmedTF: true });
                      scheduler.confimationDeleteOrder(resultData.dataToRemoveResource);
                    }
                  },
                });
              } else {
                scheduler.customReloadAll();
              }
            }
          });
        }
      });
  }
  setWorkshopDay() {
    const modalRef = this.modalService.open(SchedulerSetWorkshopDays, { size: 'xl' });
    modalRef.componentInstance.actionSetWorkshopDay = true;
    modalRef.componentInstance.globalData = this.globalData;
    modalRef.componentInstance.defaultBranch = this.defaultBranch;
    modalRef.componentInstance.currentDate = this.currentDate;
    modalRef?.result.then((result) => {
      if (result) {
        scheduler.customReloadAll();
      }
    });
  }

  resourceChange() {
    const modalRef = this.modalService.open(NgbdModalResourceContent, { size: 'xl' });
    modalRef.componentInstance.actionChangeResource = true;
    //remove resource with resourceID 1 from the list
    modalRef.componentInstance.resourceList = this.resourceListForWeekView.filter((resource) => resource.resourceID !== 1);
    modalRef.componentInstance.globalData = this.globalData;
    modalRef.componentInstance.defaultBranch = this.defaultBranch;
    modalRef.componentInstance.currentDate = this.currentDate;
    modalRef?.result.then((result) => {
      if (result) {
        scheduler.clearAll();
        scheduler.customReloadAll();
        /// this.loadTimelineScheduler(this.currentDate);
      }
    });
  }

  legendView() {
    this.showLegendModal = true;
    this.showSelectDateModal = false;
    if (!this.vehicleStatusLegend) {
      this.eventService
        .listWorkshopLegend({})
        .pipe(takeUntil(this.unSubscribe$))
        .subscribe((data) => {
          this.vehicleStatusLegend = data?.SearchResults.filter((el) => el.group === 'VEHICLE STATUS');
          this.jobTypeLegend = data?.SearchResults.filter((el) => el.group === 'JOB TYPE');
          this.customerTypeLegend = data?.SearchResults.filter((el) => el.group === 'CUSTOMER TYPE');
          this.modalService.open(this.modalBox, { size: 'lg', backdrop: 'static' });
        });
    } else {
      this.modalService.open(this.modalBox, { size: 'lg', backdrop: 'static' });
    }
  }

  goToTimelineView() {
    this.router.navigate(['/pos/scheduler/' + this.currentDate + '/timeline']).then(() => {
      if (!localStorage.getItem('preload')) {
        localStorage.setItem('preload', 'preloaded');
        location.reload();
      }
    });
  }

  handleAddResource() {
    if (!this.globalData) {
      this.eventService
        .fetchWorkshopHours({
          branch: this.defaultBranch,
        })
        .subscribe((data) => {
          this.globalData = data[0]?.resourceArray[0];
          this.resourceAdd();
        });
    } else {
      this.resourceAdd();
    }
  }

  resourceAdd() {
    this.eventService
      .fetchResourceListV2({
        branch: this.defaultBranch,
        date: this.currentDate,
      })
      .pipe(takeUntil(this.unSubscribe$))
      .subscribe((data) => {
        if (data?.ErrorFlag === '0') {
          const modalRef = this.modalService.open(NgbdModalResourceContent, { size: 'xl' });
          modalRef.componentInstance.actionAddResource = true;
          modalRef.componentInstance.availableResources = data?.resourceList;
          modalRef.componentInstance.globalData = this.globalData;
          modalRef.componentInstance.defaultBranch = this.defaultBranch;
          modalRef.componentInstance.currentDate = this.currentDate;
          modalRef?.result.then((result) => {
            if (result) {
              scheduler.customReloadAll();
            }
          });
        }
      });
  }

  goToWeekView() {
    this.router.navigate(['/pos/scheduler/' + this.currentDate + '/week']).then(() => {
      if (!localStorage.getItem('preload')) {
        localStorage.setItem('preload', 'preloaded');
        location.reload();
      }
    });
  }

  goToDate(d: NgbDateStruct) {
    this.day = d.day;
    this.month = d.month;
    this.year = d.year;
    this.currentDate = `${d.day}/${d.month}/${d.year}`;
    this.adjustedCurrentDate = moment(this.currentDate, 'DD/MM/YYYY').subtract(1, 'days').format('DD/MM/YYYY');
    scheduler.clearAll();
    this.initializeWeekView();
  }

  addworkshopSchedulerTemplates(context) {
    scheduler.config.tooltip_hide_timeout = 10;
    scheduler.templates.tooltip_text = function (start, end, event) {
      if (context.showingContextMenu || event?.info === 'info') {
        return;
      }
      const splitJobText = event?.data?.JobSplitText ? '<b>Split Job:</b> ' + event?.data?.JobSplitText + '<br/>' : '';
      const eventText = event?.text ? '<b>Task:</b> ' + event?.text : '';
      const eventCustomer = event.data?.CustomerName ? '<br/><b>Customer:</b> ' + event.data?.CustomerName : '';
      const billedHours = event.data?.StandardFitHours ? '<br/><b>Billed Fit Hours:</b> ' + event.data?.StandardFitHours : '';
      const scheduledHours = event.data?.ScheduledHours ? '<br/><b>Scheduled Hours:</b> ' + event.data?.ScheduledHours : '';
      const vehicleStatus = event.data?.VehicleStatus ? '<br/><b>Vehicle Status:</b> ' + event.data?.VehicleStatus : '';
      const jobType = event.data?.JobType ? '<br/><b>Job Type:</b> ' + event.data?.JobType : '';
      const warningMsg = event.data?.ValidSO === 'N' ? "<br/><span style='color:red'><b>Warning:</b> No open fit lines remaining</span>" : '';
      const date =
        allUnallocateSectionID.some((el) => el === event.section_id) === false
          ? '<br/><b>Start:</b> ' + start.toLocaleDateString('it-IT') + '<br/><b>End:</b> ' + end.toLocaleDateString('it-IT')
          : '';
      return splitJobText + eventText + eventCustomer + billedHours + scheduledHours + vehicleStatus + jobType + date + warningMsg;
    };
  }

  orderDetailCard() {
    const modalRef = this.modalService.open(NgbdModalOrderDetailCard, { size: 'xl', backdrop: 'static' });
    modalRef.componentInstance.actionOrderDetailCard = true;
    modalRef.componentInstance.resourceList = this.resourceList;
    modalRef.componentInstance.globalData = this.globalData;
    modalRef.componentInstance.defaultBranch = this.defaultBranch;
    modalRef.componentInstance.currentDate = this.currentDate;
    modalRef.componentInstance.currentEventData = this.currentEventData?.data;
    modalRef.componentInstance.brandDefaultsPhoneDigits = this.brandDefaults?.phoneDigits;
    //set currentEventData resourceAssigned to empty array
    modalRef.componentInstance.currentEventData.ResourceAssigned = [];
    modalRef.componentInstance.jobTypeList = this.listWorkshopJobTypes;
    modalRef.componentInstance.allocated = this.currentEventData?.section_id && this.currentEventData?.section_id !== 1 ? true : false;
    modalRef?.result.then((result) => {
      if (result) {
        this.orderDetailCardLoaded = false;
        const resourceListSet = new Set(this.currentEventData?.data?.ResourceAssigned?.map((item) => item?.ResourceID));
        const uniqueTechnicianList = result?.technicianResource?.filter((item) => !resourceListSet.has(item?.resourceID));
        const uniqueOtherList = result?.otherResource?.filter((item) => !resourceListSet.has(item?.resourceID));
        uniqueTechnicianList?.map((el) => {
          scheduler.addEventNow({
            start_date: this.currentEventData?.start_date,
            end_date: this.currentEventData?.end_date,
            text: this.currentEventData?.text,
            section_id: el.resourceID,
          });
        });
        uniqueOtherList?.map((el) => {
          scheduler.addEventNow({
            start_date: this.currentEventData?.start_date,
            end_date: this.currentEventData?.end_date,
            text: this.currentEventData?.text,
            section_id: el.resourceID,
          });
        });
        if (!this.isEventCollision) {
          const resourceListToUpdate = result?.technicianResource?.map((data) => {
            return {
              resourceID: data.resourceID,
              allocationTypeCode: '',
              allocationPercentage: 100,
            };
          });
          if (result?.otherResource?.length > 0) {
            const otherResourceToUpdate = result?.otherResource?.map((data) => {
              return {
                resourceID: data.resourceID,
                allocationTypeCode: '',
                allocationPercentage: 100,
              };
            });
            otherResourceToUpdate.map((el) => resourceListToUpdate.push(el));
          }

          const resource = [
            {
              resourceID: this.currentEventData?.section_id,
              allocationTypeCode: '',
              allocationPercentage: 100,
            },
          ];
          const orderDataToUpdate = {
            branch: this.defaultBranch,
            jobID: this.currentEventData?.data?.JobID,
            scheduledHours: !result?.allocate ? 0 : this.currentEventData?.data?.ScheduledHours,
            orderNumber: this.currentEventData?.data?.OrderNumber,
            orderType: this.currentEventData?.data?.OrderType,
            description: result?.jobDescription,
            resources: result?.allocate ? resource : [],
            startTime:  this.currentEventData?.data?.WorkshopStartTime,
            endTime: this.currentEventData?.data?.WorkshopEndTime,
            startDate: result?.fitDate,
            endDate: result?.fitDate,
            jobTypeCode: result?.jobTypeCode,
            vehicleStatusCode: this.currentEventData?.data?.VehicleStatusCode ?? '00',
            jobOwner: result?.jobOwner ?? '',
            customerPhone: result?.customerPhone,
          };
          this.eventService.maintainOrderBooking(orderDataToUpdate).then((data) => {
            if (data) {
              this.orderDetailCardLoaded = false;
              this.reloadRecords();
            }
          });
        } else {
          //this.showCollisionAlert();
        }
      } else {
        this.orderDetailCardLoaded = false;
      }
    });
  }

  fetchWorkshopTaskList() {
    return new Promise((resolve) => {
      this.eventService
        .listWorkshopTask({})
        .pipe(takeUntil(this.unSubscribe$))
        .subscribe((data) => {
          resolve(data);
        });
    });
  }
  fetchWorkshopJobType() {
    return new Promise((resolve) => {
      this.eventService
        .listWorkshopJobTypes({})
        .pipe(takeUntil(this.unSubscribe$))
        .subscribe((data) => {
          resolve(data);
        });
    });
  }

  getListWorkshopVehicleStatus() {
    return new Promise((resolve) => {
      this.eventService
        .listWorkshopVehicleStatus({})
        .pipe(takeUntil(this.unSubscribe$))
        .subscribe((data) => {
          resolve(data);
        });
    });
  }

  updateOrder(ev, tempResource, context) {
    const resourceList = context.resourceListForWeekView
      .filter((el) => el.resourceID === tempResource)
      .map((data) => {
        return {
          resourceID: 2721,
          allocationTypeCode: '',
          allocationPercentage: 100,
        };
      });
    const orderDataToUpdate = {
      branch: context.defaultBranch,
      jobID: ev?.data?.JobID,
      status: Number(ev?.data?.Status),
      scheduledHours: ev.data?.ScheduledHours,
      orderNumber: ev?.data?.OrderNumber,
      orderType: ev?.data?.OrderType,
      description: ev?.data.Description,
      resources: resourceList,
      startTime: Number(moment(ev?.start_date).format('HH:mm:ss').replace(/:|_/g, '')),
      endTime: Number(moment(ev?.end_date).format('HH:mm:ss').replace(/:|_/g, '')),
      startDate: moment(ev.start_date).format('DD/MM/YYYY'),
      endDate: moment(ev.end_date).format('DD/MM/YYYY'),
    };
    context.eventService.maintainOrderBooking(orderDataToUpdate).then((data) => {
      if (data) {
        context.reloadRecords();
      }
    });
  }

  onDateClick(dateValue: string) {
    this.router.navigate(['/pos/scheduler/' + dateValue + '/timeline']);
  }

  clearGreyOut() {
    var elements = document.querySelectorAll('[data-section-id]');
    elements.forEach(function (element) {
      // Get the value of data-section-id
      var sectionId = element.getAttribute('data-section-id');
      if (sectionId !== String(1)) {
        element.classList.remove('grey-out');
      }
    });
  }

  openFullscreen() {
    document.querySelectorAll('.section1').forEach((element) => element.classList.add('navbarHide'));

    this.fullScreen = true;
    if (this?.elem?.requestFullscreen) {
      this?.elem?.requestFullscreen();
    } else if (this.elem.mozRequestFullScreen) {
      /* Firefox */
      this?.elem?.mozRequestFullScreen();
    } else if (this.elem.webkitRequestFullscreen) {
      /* Chrome, Safari and Opera */
      this?.elem?.webkitRequestFullscreen();
    } else if (this.elem.msRequestFullscreen) {
      /* IE/Edge */
      this?.elem?.msRequestFullscreen();
    }
  }
  /* Close fullscreen */
  closeFullscreen() {
    document.querySelectorAll('.section1').forEach((element) => element.classList.remove('navbarHide'));

    this.fullScreen = false;
    if (this?.document?.exitFullscreen) {
      this?.document.exitFullscreen();
    } else if (this.document?.mozCancelFullScreen) {
      /* Firefox */
      this?.document.mozCancelFullScreen();
    } else if (this.document?.webkitExitFullscreen) {
      /* Chrome, Safari and Opera */
      this?.document?.webkitExitFullscreen();
    } else if (this.document?.msExitFullscreen) {
      /* IE/Edge */
      this?.document?.msExitFullscreen();
    }
  }
  showTooltip(id, text) {
    let tooltip = document.getElementById('tooltip' + id);
    tooltip.style.marginTop = '-65px';
    tooltip.innerHTML = text;
    tooltip.style.visibility = 'visible';
  }
  hideTooltip(id) {
    document.getElementById('tooltip' + id).style.visibility = 'hidden';
  }
  showTooltipOtherResource(id, text) {
    let tooltip = document.getElementById('tooltipOtherResource' + id);
    tooltip.style.marginTop = '-65px';
    tooltip.innerHTML = text;
    tooltip.style.visibility = 'visible';
  }

  onCalendarDateSelected(date: NgbDateStruct) {
    this.goToDate(date);
  }

  onCalendarMonthNavigated(event: any) {
    this.currentMonth = event?.next?.month;
  }

  onCalendarOpened(event: any) {
    // Handle any additional logic when calendar opens
  }

  taskDetailCard() {
    this.currentTaskData = this.currentTaskData ? this.currentTaskData : this.searchOrderStatus ? this.currentEventData : '';
    this.currentTaskData['data'] = this.currentTaskData?.data ? this.currentTaskData?.data : this.currentTaskData;
    const modalRef = this.modalService.open(NgbdModalTaskDetailCard, { size: 'xl', backdrop: 'static' });
    modalRef.componentInstance.actionTaskDetailCard = true;
    modalRef.componentInstance.resourceList = this.resourceList;
    modalRef.componentInstance.globalData = this.globalData;
    modalRef.componentInstance.defaultBranch = this.defaultBranch;
    modalRef.componentInstance.currentDate = this.currentDate;
    modalRef.componentInstance.jobTypeList = this.listWorkshopTasks;
    modalRef.componentInstance.currentTaskData = this.currentTaskData;
    modalRef?.result.then((result) => {
      if (result) {
        const resourceListSet = new Set(result?.currentTaskData?.ResourceAssigned?.map((item) => item.ResourceID));
        let uniqueTechnicianList = result?.technicianResource?.filter((item) => !resourceListSet.has(item.resourceID));
        let uniqueOtherList = result?.otherResource?.filter((item) => !resourceListSet.has(item.resourceID));
        if (result?.isNewEvent) {
          uniqueTechnicianList = uniqueTechnicianList.filter((el) => el.resourceID !== this.currentTaskData?.section_id);
          uniqueOtherList = uniqueOtherList.filter((el) => el.resourceID !== this.currentTaskData?.section_id);
        }
        uniqueTechnicianList?.map((el) => {
          if (!this.isEventCollision) {
            scheduler.addEventNow({
              start_date: this.currentTaskData?.start_date,
              end_date: this.currentTaskData?.end_date,
              text: this.currentTaskData?.text,
              section_id: el.resourceID,
            });
          }
        });

        uniqueOtherList?.map((el, index) => {
          if (!this.isEventCollision) {
            scheduler.addEventNow({
              start_date: this.currentTaskData?.start_date,
              end_date: this.currentTaskData?.end_date,
              text: this.currentTaskData?.text,
              section_id: el.resourceID,
            });
          }
        });
        if (!this.isEventCollision) {
          const resourceListToUpdate = result?.technicianResource?.map((data) => {
            return {
              resourceID: data.resourceID,
              allocationTypeCode: '',
              allocationPercentage: 100,
            };
          });
          if (result?.otherResource?.length > 0) {
            const otherResourceToUpdate = result?.otherResource?.map((data) => {
              return {
                resourceID: data.resourceID,
                allocationTypeCode: '',
                allocationPercentage: 100,
              };
            });
            otherResourceToUpdate?.map((el) => resourceListToUpdate.push(el));
          }

          const resource = [
            {
              resourceID: this.currentTaskData?.section_id,
              allocationTypeCode: '',
              allocationPercentage: 100,
            },
          ];
          const eventDataToCreateOrUpdate = {
            startDate: this.currentDate,
            endDate: this.currentDate,
            startTime: Number(moment(this.currentTaskData?.start_date).format('HH:mm:ss').replace(/:|_/g, '')),
            endTime: Number(moment(this.currentTaskData?.end_date).format('HH:mm:ss').replace(/:|_/g, '')),
            branch: this.defaultBranch,
            jobID: result?.isNewEvent ? 0 : result?.currentTaskData?.JobID,
            taskCode: result.jobTypeCode,
            description: result?.jobDescription,
            scheduledHours: result.scheduledHours,
            resources: resource,
            jobOwner: result?.isNewEvent ? '' : result?.currentTaskData?.JobOwner,
          };

          this.eventService.update(eventDataToCreateOrUpdate).then((data) => {
            if (data) {
              this.reloadRecords();
              this.taskDetailCardLoaded = false;
            }
          });
        } else {
          //this.showCollisionAlert();
        }
      } else {
        this.taskDetailCardLoaded = false;
        //this.cancelReload();
      }
    });
  }
}

